import { render, staticRenderFns } from "./TiendaCard.vue?vue&type=template&id=5ab757cc&scoped=true&"
import script from "./TiendaCard.vue?vue&type=script&lang=js&"
export * from "./TiendaCard.vue?vue&type=script&lang=js&"
import style0 from "./TiendaCard.vue?vue&type=style&index=0&id=5ab757cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab757cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
